import { injectApp } from "../app";
import App from "./get-started.vue";
injectApp(App);
